module.exports = __webpack_public_path__ + "media/images/icons/search-f007fabbf02e4f4ab90d3e82b7eb575d.svg";